declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '2092944278169978'
let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  // Define fbq function (same logic as the official Meta Pixel snippet)
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook Events script safely via document.head
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize the pixel
  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Fábrica de Contenido con IA',
      content_type: 'product',
      value: 9.99,
      currency: 'USD',
    })
  }
}
